var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93301 3.4H9.28053C11.7183 3.4 12.9372 3.4 13.3999 3.83783C13.7999 4.21629 13.9771 4.77383 13.8691 5.31377C13.7442 5.93841 12.7491 6.64228 10.7588 8.05002L7.50718 10.35C5.51693 11.7577 4.5218 12.4616 4.39688 13.0862C4.28889 13.6262 4.46614 14.1837 4.8661 14.5622C5.3288 15 6.54769 15 8.98549 15H9.73301M6.13301 3.4C6.13301 4.72548 5.05849 5.8 3.73301 5.8C2.40752 5.8 1.33301 4.72548 1.33301 3.4C1.33301 2.07452 2.40752 1 3.73301 1C5.05849 1 6.13301 2.07452 6.13301 3.4ZM17.333 14.6C17.333 15.9255 16.2585 17 14.933 17C13.6075 17 12.533 15.9255 12.533 14.6C12.533 13.2745 13.6075 12.2 14.933 12.2C16.2585 12.2 17.333 13.2745 17.333 14.6Z",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.3c9a1ccf73f807e81e9e98c0b2231e30.svg";
export { ForwardRef as ReactComponent };